import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    
    // Redirect specific legacy paths to their correct modern pages
    if (path.startsWith('/about-company') || path.startsWith('/about-us')) {
      navigate('/about', { replace: true });
      return;
    }
    if (path.startsWith('/contacts') || path.startsWith('/contact-us') || path === '/contact' || path === '/contact/') {
      navigate('/contact/support', { replace: true });
      return;
    }

    // Check if the path starts with a 4-digit year (old WordPress blog posts, e.g. /2019/11/...)
    const pathParts = path.split('/');
    const isYearPath = pathParts[1] && /^\d{4}$/.test(pathParts[1]);

    // Redirect other legacy WordPress, PHP, and deleted routes to the home page
    if (
      path.startsWith('/wp-') || 
      path.startsWith('/xmlrpc') ||
      path.includes('.php') ||
      path.startsWith('/home-2') ||
      path.startsWith('/mapping-drone') ||
      path.startsWith('/training-drone') ||
      path.startsWith('/app-development') ||
      path.startsWith('/elements') ||
      path.startsWith('/pricing-tables') ||
      path.startsWith('/portfolio') ||
      path.startsWith('/author') ||
      path.includes('builder') ||
      path.startsWith('/ot_') ||
      isYearPath
    ) {
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.errorCode}>404</h1>
        <h2 style={styles.title}>Oops! Sky's the limit, but this page isn't here.</h2>
        <p style={styles.message}>
          The link you followed might be broken, or the page may have been moved.
        </p>
        <Link to="/" style={styles.button}>
          Return Home
        </Link>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#0a0a0a',
    color: '#ffffff',
    textAlign: 'center',
    padding: '20px',
  },
  content: {
    maxWidth: '600px',
  },
  errorCode: {
    fontSize: '120px',
    fontWeight: 'bold',
    margin: '0',
    background: 'linear-gradient(45deg, #00c896, #0081ff)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    lineHeight: '1',
  },
  title: {
    fontSize: '24px',
    margin: '20px 0',
  },
  message: {
    fontSize: '16px',
    color: '#888',
    marginBottom: '30px',
  },
  button: {
    display: 'inline-block',
    padding: '12px 30px',
    background: '#00c896',
    color: '#000',
    textDecoration: 'none',
    borderRadius: '50px',
    fontWeight: 'bold',
    transition: 'transform 0.2s',
  },
};

export default NotFound;
